import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "relative flex w-full" }
const _hoisted_5 = { class: "flex min-w-0 flex-col md:col-span-12" }
const _hoisted_6 = { class: "space-y-4" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2" }
const _hoisted_8 = { class: "flex min-w-0 flex-col" }
const _hoisted_9 = { class: "flex min-w-0 flex-col" }
const _hoisted_10 = { class: "flex min-w-0 flex-col" }
const _hoisted_11 = { class: "flex min-w-0 flex-col" }
const _hoisted_12 = { class: "flex min-w-0 flex-col" }
const _hoisted_13 = {
  key: 0,
  class: "flex min-w-0 flex-col"
}
const _hoisted_14 = { class: "flex justify-end gap-3 pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDeleteModal = _resolveComponent("ConfirmDeleteModal")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Danh sách tài khoản" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_DataTable, {
          loading: _ctx.isLoading,
          value: $setup.list,
          paginator: true,
          stripedRows: "",
          rows: 10,
          rowsPerPageOptions: [10, 25, 50],
          rowHover: true,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          filters: $setup.filters,
          "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters) = $event)),
          globalFilterFields: ['fullname', 'username'],
          currentPageReportTemplate: "Có tổng số {totalRecords} tài khoản"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-filter-slash",
                  label: "Xoá lọc",
                  outlined: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.clearFilter()))
                }),
                _createElementVNode("span", _hoisted_4, [
                  _cache[13] || (_cache[13] = _createElementVNode("i", { class: "pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400" }, null, -1)),
                  _createVNode(_component_InputText, {
                    class: "!w-[400px] !pl-8 !pr-3",
                    modelValue: $setup.filters['global'].value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters['global'].value) = $event)),
                    placeholder: "Tìm theo tên hoặc tài khoản"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "fullname",
              header: "Họ và tên",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "username",
              header: "Tài khoản",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "phoneNumber",
              header: "Số điện thoại",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "permission",
              header: "Quyền hạn",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "civilGroupName",
              header: "Tổ",
              sortable: ""
            }),
            _createVNode(_component_Column, { header: "Hành động" }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  type: "button",
                  label: "Chỉnh sửa",
                  icon: "pi pi-pencil",
                  onClick: ($event: any) => ($setup.getUserById(slotProps.data.id))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "value", "filters"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Dialog, {
          visible: $setup.updateReg,
          "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (($setup.updateReg) = $event)),
          breakpoints: { '1500px': '80vw', '1150px': '90vw' },
          modal: true,
          closable: true,
          header: "Cập nhật tài khoản"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "mb-2 text-sm font-medium text-slate-700" }, "Họ và tên", -1)),
                  _createVNode(_component_InputText, {
                    id: "fullname",
                    type: "text",
                    modelValue: $setup.userUpdate.fullname,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.userUpdate.fullname) = $event)),
                    placeholder: "Nhập họ và tên",
                    class: "w-full"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "mb-2 text-sm font-medium text-slate-700" }, "Tên đăng nhập", -1)),
                  _createVNode(_component_InputText, {
                    id: "username",
                    type: "text",
                    modelValue: $setup.userUpdate.username,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.userUpdate.username) = $event)),
                    placeholder: "Nhập tên đăng nhập",
                    class: "w-full",
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "mb-2 text-sm font-medium text-slate-700" }, "Số điện thoại", -1)),
                  _createVNode(_component_InputText, {
                    id: "phoneNumber",
                    type: "text",
                    modelValue: $setup.userUpdate.phoneNumber,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.userUpdate.phoneNumber) = $event)),
                    placeholder: "Nhập số điện thoại",
                    class: "w-full"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "mb-2 text-sm font-medium text-slate-700" }, "Mật khẩu (tối thiểu 6 ký tự)", -1)),
                  _createVNode(_component_Password, {
                    id: "password",
                    modelValue: $setup.password,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.password) = $event)),
                    toggleMask: "",
                    feedback: false,
                    placeholder: "Để trống nếu không đổi",
                    class: "w-full"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "mb-2 text-sm font-medium text-slate-700" }, "Chọn quyền hạn", -1)),
                  _createVNode(_component_Dropdown, {
                    id: "permission",
                    modelValue: $setup.userUpdate.permission,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.userUpdate.permission) = $event)),
                    options: $setup.userPermission,
                    optionLabel: "label",
                    optionValue: "value",
                    placeholder: "Vui lòng chọn quyền hạn...",
                    onChange: $setup.selectPermission,
                    class: "w-full"
                  }, null, 8, ["modelValue", "options", "onChange"])
                ]),
                ($setup.userUpdate.permission == 'civilGroup')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "mb-2 text-sm font-medium text-slate-700" }, "Chọn tổ", -1)),
                      _createVNode(_component_Dropdown, {
                        id: "civilGroup",
                        modelValue: $setup.userUpdate.idCivilGroup,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.userUpdate.idCivilGroup) = $event)),
                        options: $setup.listCivilGroup,
                        optionLabel: "civilGroupName",
                        optionValue: "id",
                        placeholder: "Vui lòng chọn tổ...",
                        filter: true,
                        class: "w-full"
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Button, {
                  label: "Xoá",
                  severity: "danger",
                  icon: "pi pi-trash",
                  iconPos: "left",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.del($event))),
                  loading: $setup.deletingUser,
                  class: "px-4 py-2"
                }, null, 8, ["loading"]),
                _createVNode(_component_Button, {
                  label: "Cập nhật",
                  icon: "pi pi-check",
                  iconPos: "left",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.doUpdate())),
                  loading: $setup.updatingUser,
                  disabled: !$setup.valid,
                  class: "px-4 py-2"
                }, null, 8, ["loading", "disabled"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]),
      _createVNode(_component_ConfirmDeleteModal, {
        modelValue: $setup.showConfirmModal,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.showConfirmModal) = $event)),
        title: $setup.confirmTitle,
        message: $setup.confirmMessage,
        "is-loading": $setup.isConfirming,
        onConfirm: $setup.confirmDelete.confirm,
        onCancel: $setup.confirmDelete.cancel
      }, null, 8, ["modelValue", "title", "message", "is-loading", "onConfirm", "onCancel"])
    ]),
    _: 1
  }))
}